"use client";

import { cn } from "../lib/utils";

/**
 * shadcn/ui docs: https://ui.shadcn.com/docs/components/skeleton
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-neutral-200", className)}
      {...props}
    />
  );
}

type SkeletonProps = React.ComponentProps<typeof Skeleton>;

export { Skeleton, type SkeletonProps };
